export enum TRIP_MATE_OPTIONS {
  solo = "คนเดียว",
  lover = "คู่รัก",
  freidns = "เพื่อนซี้",
  family = "ครอบครัว",
}
